import React from 'react';
import VolumeOffIcon from '@mui/icons-material/VolumeOff';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import { Box, IconButton, Typography } from '@mui/material';

import { clampPercentage } from '../utils/ambienceSettings.utils';

import { useStyles } from './styles';
import AmbienceVolumeSlider from './AmbienceVolumeSlider';

export type SoundVolumeRowProps = {
  label: string;
  disabled: boolean;
  value: number;
  hasSound: boolean;
  muteButtonLabel?: string;
  onChange: (nextVolume: number) => void;
  onToggleMute: () => void;
};

export const SoundVolumeRow: React.FC<SoundVolumeRowProps> = ({
  label,
  disabled,
  value,
  hasSound,
  muteButtonLabel,
  onChange,
  onToggleMute,
}) => {
  const { classes } = useStyles();

  return (
    <Box className={classes.row}>
      <Typography variant="body2">{label}</Typography>
      <Box className={classes.sliderWrapper}>
        <AmbienceVolumeSlider
          min={0}
          max={100}
          step={1}
          value={value}
          disabled={disabled || !hasSound}
          valueLabelDisplay="auto"
          valueLabelFormat={(sliderValue) => `${sliderValue}%`}
          onChange={(_, nextValue) =>
            onChange(clampPercentage(Array.isArray(nextValue) ? nextValue[0] : nextValue))
          }
        />
      </Box>
      <IconButton
        color="primary"
        disabled={disabled || !hasSound}
        onClick={onToggleMute}
        aria-label={muteButtonLabel}>
        {value ? <VolumeUpIcon /> : <VolumeOffIcon />}
      </IconButton>
    </Box>
  );
};

export default SoundVolumeRow;
